import { useEffect, useState } from 'react';

// Local preview url for a just-picked File, or the saved url string as is. The url is created and
// revoked inside one effect so StrictMode's dev double-run can't revoke a url that is still shown.
export const useFilePreview = (value: unknown): string | undefined => {
  const [preview, setPreview] = useState<string>();

  useEffect(() => {
    if (!(value instanceof File)) {
      setPreview(undefined);
      return;
    }
    const url = URL.createObjectURL(value);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [value]);

  if (value instanceof File) return preview;
  return typeof value === 'string' && value ? value : undefined;
};
